import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import AdminHeader from '../../../components/header/AdminHeader';
import CallexLoader from '../../../components/CallexLoader';
import DeleteConfirmationModal from '../../../components/Modals/DeleteConfirmationModal';

import {
  useWhatsappList,
  whatsappBotStatusUpdate,
  whatsappDelete,
  whatsappListGet,
  whatsappQrUpdate
} from '../../../store/slices/tenantSlices/configurationSlice';
import { useUserRolePermission } from '../../../store/slices/authSlice';
import { checkModulePermission } from '../../../utils/common';
import AddEditWhatsappModal from './AddEditWhatsappModal';
import WhatsappScanSuccessModal from './WhatsappScanSuccessModal';

const Whatsapp = () => {
  const dispatch = useDispatch();
  const whatsappList = useWhatsappList();
  const userRolePermission = useUserRolePermission();

  const [openAddModal, setOpenAddModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isEdit, setIsEdit] = useState(null);
  const [isDeleteId, setIsDeleteId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isScanned, setIsScanned] = useState(false);
  // const [filter, setFilter] = useState({
  //   search: undefined
  // });

  const fetchWhatsappList = useDebouncedCallback(async () => {
    setIsLoading(true);
    try {
      // const payload = { ...filter };
      await dispatch(whatsappListGet()).unwrap();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  }, 500);

  const deleteWhatsapp = async () => {
    try {
      const response = await dispatch(whatsappDelete(isDeleteId)).unwrap();
      if (response) {
        toast.success('Record deleted successfully');
        fetchWhatsappList();
        // if (whatsappList?.data?.length === 1) {
        //   setFilter({ ...filter, page: filter?.page > 1 ? filter.page - 1 : 1 });
        // } else {
        //   fetchWhatsappList();
        // }
        setIsDeleteId(null);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const onUpdateStatus = async (editRecord) => {
    try {
      const payload = { status: !editRecord.status, id: editRecord.id };
      const response = await dispatch(whatsappQrUpdate(payload)).unwrap();
      if (response && response?.message) {
        toast.success('Record Updated Successfully');
        fetchWhatsappList();
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const onUpdateBotStatus = async (record) => {
    try {
      const payload = { is_bot: !record.is_bot, id: record.id };
      const response = await dispatch(whatsappBotStatusUpdate(payload)).unwrap();
      if (response && response?.message) {
        toast.success(response?.message);
        fetchWhatsappList();
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    fetchWhatsappList();
  }, []);

  return (
    <div>
      <AdminHeader
        title="Whatsapp"
        // isExpandSearch
        isAdd
        onAddClick={() => setOpenAddModal(true)}
        isAddDisabled={!checkModulePermission('is_add', 'Whatsapp', userRolePermission)}
        addBtnName="Add Whatsapp"
        // searchPlaceholder="Search Whatsapp"
        // search={filter.search}
        // handelSearch={(e) => setFilter({ ...filter, search: e.target.value })}
      />
      {isLoading ? (
        <Card
          className="p-0 d-flex justify-content-center align-items-center m-0"
          style={{ height: 'calc(100vh - 165px)' }}>
          <CallexLoader />
        </Card>
      ) : whatsappList?.data?.length > 0 &&
        checkModulePermission('is_view', 'Whatsapp', userRolePermission) ? (
        <Card className="p-0 position-relative m-0">
          <div className="daily-report-table" style={{ height: 'calc(100vh - 210px)' }}>
            <table className="report-list-table">
              <thead>
                <tr>
                  <th>Number</th>
                  <th className="text-center" style={{ width: '120px' }}>
                    Status
                  </th>
                  <th className="text-center" style={{ width: '120px' }}>
                    Bot
                  </th>
                  <th className="text-center" style={{ width: '120px' }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {whatsappList?.data?.map((val, index) => {
                  return (
                    <tr key={index}>
                      <td>{val?.whatsapp_number}</td>
                      <td className="text-center">{String(val?.status)}</td>
                      <td className="text-center">
                        <div
                          className={`cursor-pointer d-flex justify-content-center align-items-center ${
                            val?.is_bot ? 'text-info' : 'text-danger'
                          } ${
                            !checkModulePermission('is_edit', 'Whatsapp', userRolePermission)
                              ? 'callex-disabled'
                              : ''
                          }`}>
                          {val?.is_bot ? (
                            <Icon.ToggleRight
                              size={16}
                              onClick={() => {
                                if (
                                  checkModulePermission('is_edit', 'Whatsapp', userRolePermission)
                                ) {
                                  onUpdateBotStatus(val);
                                }
                              }}
                            />
                          ) : (
                            <Icon.ToggleLeft
                              size={16}
                              onClick={() => {
                                if (
                                  checkModulePermission('is_edit', 'Whatsapp', userRolePermission)
                                ) {
                                  onUpdateBotStatus(val);
                                }
                              }}
                            />
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-around align-items-center">
                          <div
                            className={`cursor-pointer text-info ${
                              !checkModulePermission('is_edit', 'Whatsapp', userRolePermission)
                                ? 'callex-disabled'
                                : ''
                            }`}>
                            <Icon.Edit
                              size={16}
                              onClick={() => {
                                if (
                                  checkModulePermission('is_edit', 'Whatsapp', userRolePermission)
                                ) {
                                  setEditRecord(val);
                                  setIsEdit(true);
                                  setOpenAddModal(true);
                                }
                              }}
                            />
                          </div>
                          <div
                            className={`cursor-pointer text-info ${
                              !checkModulePermission('is_edit', 'Whatsapp', userRolePermission)
                                ? 'callex-disabled'
                                : ''
                            }`}>
                            {val?.status ? (
                              <Icon.ToggleRight
                                size={16}
                                onClick={() => {
                                  if (
                                    checkModulePermission('is_edit', 'Whatsapp', userRolePermission)
                                  ) {
                                    onUpdateStatus(val);
                                  }
                                }}
                              />
                            ) : (
                              <Icon.ToggleLeft
                                size={16}
                                onClick={() => {
                                  if (
                                    checkModulePermission('is_edit', 'Whatsapp', userRolePermission)
                                  ) {
                                    onUpdateStatus(val);
                                  }
                                }}
                              />
                            )}
                          </div>
                          <div
                            className={`cursor-pointer text-danger ${
                              !checkModulePermission('is_delete', 'Whatsapp', userRolePermission)
                                ? 'callex-disabled'
                                : ''
                            }`}>
                            <Icon.Trash
                              size={16}
                              onClick={() => {
                                if (
                                  checkModulePermission('is_delete', 'Whatsapp', userRolePermission)
                                ) {
                                  setIsDeleteId(val?.id);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Card>
      ) : (
        <Card
          className="p-0 d-flex justify-content-center align-items-center no-data m-0"
          style={{ height: 'calc(100vh - 165px)' }}>
          No data available
        </Card>
      )}
      <DeleteConfirmationModal
        isOpen={!!isDeleteId}
        onCloseClick={() => setIsDeleteId(null)}
        onDeleteClick={() => deleteWhatsapp()}
      />
      {openAddModal && (
        <AddEditWhatsappModal
          isOpen={openAddModal}
          setIsScanned={setIsScanned}
          onCloseClick={(apiCall = false) => {
            setOpenAddModal(false);
            setEditRecord(null);
            setIsEdit(false);
            if (apiCall) {
              setIsScanned(true);
            }
          }}
          isEdit={isEdit}
          editRecord={editRecord}
        />
      )}
      {isScanned && (
        <WhatsappScanSuccessModal
          isOpen={isScanned}
          onDoneClick={() => {
            fetchWhatsappList();
            setIsScanned(false);
          }}
        />
      )}
    </div>
  );
};

export default Whatsapp;
